// "Tell the family WhatsApp": links that open WhatsApp with a message ready to send. Nothing is sent anywhere by us:
// wa.me just opens WhatsApp (the app on phones, WhatsApp Web on computers) and the visitor picks the chat.
// The lines come from Theme settings → Chutzpah (one per line, {url} = the page being shared). Each link already
// carries the first line, so it works without this file; with it, every click moves on to the next line.
(() => {
  const link = (text) => `https://wa.me/?text=${encodeURIComponent(text)}`;
  const init = (root = document) => root.querySelectorAll('a[data-wa-lines]').forEach((a) => {
    if (a.dataset.ready) return;
    a.dataset.ready = '1';
    let lines = [];
    try { lines = JSON.parse(a.dataset.waLines).filter(Boolean); } catch { return; }
    if (!lines.length) return;
    const url = a.dataset.url || location.origin;
    let next = 0;
    // The browser reads href after click handlers run, so swapping it here still opens a normal link
    a.addEventListener('click', () => { a.href = link(lines[next++ % lines.length].replaceAll('{url}', url)); });
  });
  init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
